// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3KerX","image-container":"styles_image-container__Ve0kU","support-text":"styles_support-text__1GZdV","btn-container":"styles_btn-container__1VmFk"};